import { Box, Card, CardContent } from "@mui/material";
import Typography from "@mui/material/Typography";
import ResponsiveCircularLoading from "../ResponsiveCircularLoading";
import Grid from "@mui/material/Grid";
import { numberWithSpaces } from "../../services/helper";

export default function StatsCard({ title, value, unit, precision, loading, multiplier = 1, titleEndIcon = '', valueEndElement, children }) {
    value = (value ?? 0) * multiplier;
    return (
        <Card sx={{ height: "100%" }}>
            <CardContent sx={{ height: "100%" }}>
                <Grid container direction={'column'} justifyContent={'space-between'} height={'100%'}>
                    <Grid item>
                        <Typography sx={{ fontSize: 14, display: 'flex', alignItems: 'center', flexWrap: 'wrap', overflowWrap: 'anywhere' }} color="text.secondary" gutterBottom>
                            {title}
                            {titleEndIcon}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {loading && <ResponsiveCircularLoading />}
                            {!loading &&
                                <Typography variant="h5" component="div">
                                    {numberWithSpaces(precision ? value.toFixed(precision) : value)} {unit ?? ''}
                                </Typography>
                            }
                            {valueEndElement}
                        </Box>
                    </Grid>
                    {children && <Grid item>{children}</Grid>}
                </Grid>
            </CardContent>
        </Card>
    );
}